export enum Relation {
  RELATION_UNSPECIFIED = 'RELATION_UNSPECIFIED',
  RELATION_CHILD = 'RELATION_CHILD',
  RELATION_ADULT = 'RELATION_ADULT',
}

export interface Person {
  firstName?: string;
  lastName?: string;
  title?: string;
  birthdate?: string;
  relation?: Relation;
}

export interface RiskProps {
  adultsList?: Array<Person>;
  childrenList?: Array<Person>;
  insuredPersonId?: string;
}

export class Risk {
  adultsList?: Array<Person>;
  childrenList?: Array<Person>;
  insuredPersonId?: string;

  constructor(props?: RiskProps) {
    if (props) {
      this.adultsList = props.adultsList?.length
        ? props.adultsList
        : [{ relation: Relation.RELATION_ADULT }];
      this.childrenList = props.childrenList;
      this.insuredPersonId = props.insuredPersonId;
    }
  }

  static computePersonsCount(risk: RiskProps) {
    const adultsCount = risk?.adultsList?.length ?? 0;
    const childrenCount = risk?.childrenList?.length ?? 0;

    return adultsCount + childrenCount;
  }
}
